import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App, { bootApp } from './App';
import './styles/globals.css';

// Boot before mounting: the prerendered landing page in index.html stays on
// screen until the app can take over. See bootApp() for why.
void bootApp().then((state) => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App state={state} />
      </BrowserRouter>
    </StrictMode>,
  );
});
